import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { nav } from '@app/shared/utils';
import { KpiActionBase } from './kpi-action-base';

@Injectable({
  providedIn: 'root'
})
export class KpiActionGoodQuantityService extends KpiActionBase {
  constructor(private router: Router) {
    super();
  }

  public execute(): void {
    this.router.navigate([nav.routes.run]);
  }
}
